import React, { useState } from "react";
import InputComp from "../../SubComp/InputComp/InputComp";
import "./ChangeInfo.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

const ChangeInfo = () => {

  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(<FontAwesomeIcon icon={faEye} />);





  const handleToggle = () => {
    console.log('a');
    
    document.getElementById('box').forEach(data => {

      let show = false;
      data.addEventListener('onClick', () => {
        console.log('j');
        // show = !show;
        // data.parentElement.children[0].setAttribute(
        //   'type',
        //   show ? 'text' : 'password'
        // )
      });
    })
  }
  // const handleToggle = (id) => {
  //   if (type === 'password') {
  //     setIcon(<FontAwesomeIcon icon={faEyeSlash} />);
  //     setType('text');
  //   }
  //   else {
  //     setIcon(<FontAwesomeIcon icon={faEye} />);
  //     setType('password');
  //   }
  // }
  return (
    <div>
      <div className="mb-5">
        <h4 className="mb-5 semibold">Account Information</h4>
        <InputComp title="Username" type="text" placeholder="User Name" />
      </div>
      <div>
        <h4 className="mb-5 semibold">Change Password</h4>
        <div class="mb-3 row align-items-center edit-input">
          <div class="col-sm-2">
            <label for="inputPassword6" class="col-form-label">Current Password</label>
          </div>
          <div class="col-sm-4 d-flex">
            <div className='input-field d-flex align-items-center'>
              <input type={type} class="form-control form-control-lg" placeholder="Current Password" />
              <span className="cursor">{icon}</span>
            </div>
          </div>
        </div>
        <div class="mb-3 row align-items-center edit-input">
          <div class="col-sm-2">
            <label for="inputPassword6 " class="col-form-label">New Password</label>
          </div>
          <div class="col-sm-4 d-flex">
            <div className='input-field d-flex align-items-center'>
              <input type={type} class="form-control form-control-lg" placeholder="New Password" />
              <span className="cursor" id="box" onClick={handleToggle}>{icon}</span>
            </div>
          </div>
        </div>

        <div class="mb-3 row align-items-center edit-input">
          <div class="col-sm-2">
            <label for="inputPassword6" class="col-form-label">Confirm Password</label>
          </div>
          <div class="col-sm-4 d-flex">
            <div className='input-field d-flex align-items-center'>
              <input type={type} class="form-control form-control-lg" placeholder="Confirm Password" />
              <span className="cursor box" >{icon}</span>
            </div>
          </div>
        </div>

      </div>

      <div className="row">
        <div className="col-sm-2"></div>
        <div className="col-sm-4">
          <Link to="/myprofile">
            <button type="button" className="contact-button " >
              Save
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ChangeInfo;
